import { Mutation } from 'graphql/generated/graphqlTypes';

export const mockedBulkAddVisitorsToVisitorGroupsData = (): Pick<Mutation, 'bulkAddVisitorsToVisitorGroups'> => ({
  bulkAddVisitorsToVisitorGroups: {
    updated: [],
    errors: []
  }
});
